import React, { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';
import { useNavigate } from 'react-router-dom';
import BASE_URL from '../../../config/apiConfig';

export function PasswordRecover() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  // Submit form
  const handleForgotPass = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${BASE_URL}/api/user/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('user_email', email);
        navigate('/verifyotp'); // Navigate to OTP page on success
      } else {
        console.error('Error occurred while sending OTP');
      }
    } catch (error) {
      console.error('Error during OTP verification:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(to right, #f8fafc, #edf2fb)',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 400,
          padding: 4,
          boxShadow: 3,
          borderRadius: 2,
          backgroundColor: '#fff',
        }}
      >
        <Typography variant="h5" align="center" gutterBottom>
          Forgot Your Password?
        </Typography>
        <Typography variant="body2" align="center" gutterBottom sx={{ mb: 3 }}>
          Enter your email to receive an OTP for password recovery
        </Typography>

        <Box component="form" onSubmit={handleForgotPass} display="flex" flexDirection="column">
          <TextField
            fullWidth
            name="forgot_password"
            label="Enter Email ID"
            InputLabelProps={{ shrink: true }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 3 }}
            variant="outlined"
          />

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={loading}
            sx={{
              backgroundColor: '#51833a',
              color: '#fff',
              mb: 2,
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#4a7a32',
              },
            }}
          >
            Send OTP
          </LoadingButton>
        </Box>
      </Box>
    </Box>
  );
}

export default PasswordRecover;
